<template>
  <div>
    <list
      row-key="MenuId"
      ref="list"
      unit="菜单"
      :expand-all-row="true"
      :page="false"
      :get-data-func="getDataFunc"
      :delete-func="api.delete"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <el-table-column prop="MenuName" label="菜单名称" :width="$store.state.isMB?'180':'350'" />
        <el-table-column prop="Url" label="路径" min-width="110" />
        <el-table-column prop="Sort" label="排序" align="center" :width="$store.state.isMB?'65':''" sortable="custom" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list
  },
  data() {
    return {
      api: require("@/api/sy/menu").default,
      params: {},
      sourceData: null
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
         this.api.list(params).then(res => {     
          this.sourceData = res.Data;
          let Data = this.$commonJs.toTreeData(res.Data,"MenuId");
          resolve({ Data });
        });
      });
    }
  }
};
</script>